import Signin from '../pages/User/SignIn';
import CreateAccount from '../pages/User/CreateAccount';
import EmailVerification from '../pages/User/Emailverification';

// Dashboard
import Home from '../pages/Home';

// Application
import Application from '../pages/Application';

// Settings
import Settings from '../pages/Settings';

// Define your routes
const authProtectedRoutes = [
  { path: "/dashboard", component: <Home /> },
  { path: "/application", component: <Application /> },
  { path: "/settings", component: <Settings /> },
];

const publicRoutes = [
  // Signin
  { path: "/signin", component: <Signin /> },
  { path: "/emailverify", component: <EmailVerification /> },

  // CreateAccount
  { path: "/create-account", component: <CreateAccount /> },
];

export { authProtectedRoutes, publicRoutes };
